export default __webpack_public_path__ + "static/media/msg-icon2.01ed8384.png";